import classNames from 'classnames'
import React from 'react'
import Table from '../ProductConfigurationTable'
import { LoadingSpinner } from '@cfs-fixings/shared'

type PropTypes = {
  children: React.ReactNode
  isLoading?: Boolean
  columnCount?: number
}

const Body = ({ children, isLoading = false, columnCount = 1 }: PropTypes) => {
  return (
    <tbody className={classNames('transition-all relative', children ? 'opacity-100' : 'opacity-0')}>
      {
        isLoading
          && <Table.Row>
            {
              ...Array.from({ length: columnCount }).map((_, index) => (
                <Table.Cell
                  key={`table-loading-column-${index}`}
                  className="w-full h-full"
                >
                  <p className="hidden">...</p>
                </Table.Cell>
              ))
            }
            <Table.Cell className="absolute inset-0 flex justify-center items-center">
              <LoadingSpinner className="h-4 w-4" />
            </Table.Cell>
          </Table.Row>
      }
      {
        !isLoading
          && children
      }
    </tbody>
  )
}

export default Body
